'use client';

import { createContext, useContext } from 'react';

import {
  SiteSettings,
  SITE_SETTINGS_FALLBACK,
} from '@/src/utils/shared/siteSettings';

const SiteSettingsContext = createContext<SiteSettings>(SITE_SETTINGS_FALLBACK);

// Provided once from the root server layout; lets client components (e.g. the
// Footer, the contact page) read global Site Settings without re-fetching.
export const SiteSettingsProvider = ({
  value,
  children,
}: {
  value: SiteSettings;
  children: React.ReactNode;
}) => (
  <SiteSettingsContext.Provider value={value}>
    {children}
  </SiteSettingsContext.Provider>
);

export const useSiteSettings = () => useContext(SiteSettingsContext);
